<template>
<b-modal id="modal-about" size="lg" :title="$t('ABOUT_AND_RULES')">
    <div class="row text-center justify-content-center mt-4">
        <div class="col-8 modal-body-content">
            {{ 'ABOUT_INFO_ONE' | translate }}
        </div>   
    </div>
    <div class="row justify-content-center mt-4 pt-4 pb-4">
        <div class="col-4">
            <BlockHead :blockhead="mockHeads[1]" />
        </div>
    </div>

    <div class="row text-center justify-content-center mt-4">
        <div class="col-8 modal-body-content">
            {{ 'ABOUT_INFO_TWO' | translate }}
        </div>   
    </div>

     <div class="row justify-content-center mt-4 pt-4">
        <div class="col-4">
            <BlockHead :blockhead="mockHeads[2]" :warLogic="{ defeatedPosition: 'bottom' }" />
        </div>
    </div>

     <div class="row justify-content-center mt-4">
        <div class="col-4">
            <BlockHead :blockhead="mockHeads[3]" :warLogic="{ defeatedPosition: 'right' }" />
        </div>
        <div class="col-4">
            <BlockHead :blockhead="mockHeads[1]" :warLogic="{ defeatedPosition: 'bottom' }" />
        </div>
        <div class="col-4">
            <BlockHead :blockhead="mockHeads[4]" :warLogic="{ defeatedPosition: 'left' }" />
        </div>
    </div>

     <div class="row justify-content-center mt-4 pb-4">
        <div class="col-4">
            <BlockHead :blockhead="mockHeads[5]" />
        </div>
    </div>

    <div class="row text-center justify-content-center mt-4">
        <div class="col-8 modal-body-content">
            {{ 'ABOUT_INFO_THREE' | translate }}
        </div>   
    </div>

  <div class="row justify-content-center mt-4 pt-4 pb-4">
        <div class="col-4">
            <BlockHead :blockhead="mockHeads[4]" />
        </div>
        <div class="col-4">
            <BlockHead :blockhead="mockHeads[3]" :warLogic="{ defeatedPosition: 'right' }" />
        </div>
        <div class="col-4">
            <BlockHead :blockhead="mockHeads[1]" />
        </div>
    </div>

    <div class="row text-center justify-content-center mt-4">
        <div class="col-8 modal-body-content">
            {{ 'ABOUT_INFO_FOUR' | translate }}
        </div>   
    </div>

    <div class="row text-center justify-content-center mt-4">
        <div class="col-8 modal-body-content">
            <div class="mt-3">
                {{ 'ABOUT_INFO_FIVE' | translate }}
            </div>
        </div>   
    </div>

    <div class="row text-center justify-content-center mt-4">
        <div class="col-8 modal-body-content">
            <h1>
                {{ 'GAME_ON' | translate }}
            </h1>
        </div>   
    </div>

    <div slot="modal-footer" class="text-center">        
        <button type="button" class="btn btn-secondary" @click="hideModal">
            {{ 'CLOSE' | translate }}
        </button>
    </div>
</b-modal>    
</template>
 
<script>
import { mapGetters } from "vuex";
import BlockHead from "./BlockHead";
import { mockHeads } from "../util/mockHeads";

export default {
    name: "modal-about",
    components: { BlockHead },
    data () {
        return {
            mockHeads: mockHeads
        }
    },
    computed: {
        ...mapGetters({})
    },
    methods: {
        hideModal () {
            this.$root.$emit('bv::hide::modal','modal-about');
        }
    }
};
</script>

<style scoped lang="less">
@import "../assets/less/modal.less";
@import "../assets/less/app.less";

.modal-body-content {
    color: #fff;
}

#modal-about {
    .row {
        padding: 0 10px;
    }

    h1 {
        font-size: 42px;
        font-family:  'Cabin Sketch', cursive;
    }
}

</style>


// WEBPACK FOOTER //
// src/components/ModalAbout.vue